<template>
  <div class="amount-input">
    <el-input class="zwx-input" v-model="inputValue" :placeholder="placeholder" :maxlength="maxlength" @input="$validate.nonnegativeDouble($data, 'inputValue', numbers, digits)" @focus="amountInputFocus" @blur="amountInputBlur" :clearable="clearable" :disabled="disabled" :style="`width:${width}!important`"></el-input>
    <div class="amount-unit" v-if="ifUnit">{{ unitText }}</div>
  </div>
</template>

<script>
export default {
  name: 'AmountInput',
  model: {
    prop: 'value',
    event: 'propEvent',
  },
  components: {},
  props: {
    value: { type: String, default: '' },
    width: { type: String, default: '200px' },
    placeholder: { type: String, default: '' },
    maxlength: { type: String, default: '' },
    numbers: { type: Number },
    digits: { type: Number },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    ifUnit: { type: Boolean, default: false },
    unitText: { type: String, default: '元' },
  },
  data() {
    return {
      api: this.$store.state.api,
      inputValue: this.value,
    }
  },
  created() { },
  mounted() { },
  watch: {
    inputValue(val) {
      this.$emit('propEvent', val)
    },
    value: {
      handler() {
        if (this.value != undefined) {
          this.inputValue = this.value
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {},
  methods: {
    /**
     * 输入框失焦事件
     */
    amountInputBlur() {
      if (this.$CommonTools.verifyIsNotBlank(this.inputValue)) {
        this.inputValue = this.$CommonTools.formatMoney(this.inputValue)
      }
    },
    /**
     * 输入框点击事件
     */
    amountInputFocus() {
      if (this.$CommonTools.verifyIsNotBlank(this.inputValue)) {
        this.inputValue = this.inputValue.replaceAll(',', '')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.amount-input {
  .amount-unit {
    display: inline-flex;
    width: 38px;
    height: 32px;
    background: #eaeff5;
    border: 1px solid #a8bbcf;
    border-radius: 0px 2px 2px 0px;
    justify-content: center;
    align-items: center;
    position: absolute;
    margin-left: -1px;
    font-size: 14px;
    color: #1f2d3d;
    line-height: 14px;
  }
}
</style>
